import { QueryClient } from "react-query";

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: false,
			staleTime: 30000,
		},
	},
});

export function refreshCustomerQueryCache() {
	queueMicrotask(() => {
		queryClient.invalidateQueries(undefined, { refetchActive: true });
	});
}
